import type {MouseEvent, ReactElement} from 'react';
import React, {useState} from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './ai-image-tooltip-text.module.scss';
import {copyToClipboard} from '@Utils/clipboard.util';
import {GA4EventName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from "@Components/clickable-div";

interface AiImageTooltipTextProps {
  prompt: string;
}

export function AiImagePromptText({...props}: AiImageTooltipTextProps): ReactElement<any> {
  const [isCopiedClicked, setIsCopiedClicked] = useState(false);
  const onCopy = (e: MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();
    void copyToClipboard(props.prompt);
    trackPosterBuilderGA4Events(GA4EventName.AI_IMAGE_PROMPT_COPY);
    setIsCopiedClicked(true);

    setTimeout(() => {
      setIsCopiedClicked(false);
    }, 2000);
  };

  const getCopiedTextElement = (): ReactElement<HTMLDivElement> => {
    return (
      <div className={`spacing-p-2 flex-center spacing-m-1 radius-8 hover-transition-all ${styles.container}`}>
        <Icon icon={'icon-check'} size={IconSize.SIZE_ICON_16} className={'content-body-white spacing-m-r-1'} />
        <Text size={TextSize.XXSMALL} className={'content-body-white'} val={window.i18next.t('pmwjs_copied')} />
      </div>
    );
  }

  const getPromptTextElement = (): ReactElement<HTMLDivElement> => {
    return (
      <ClickableDiv className={`spacing-p-2 flexbox flex-align-items-center spacing-m-1 radius-8 hover-transition-all ${styles.container}`} onClick={onCopy}>
        <Icon icon={'icon-copy'} size={IconSize.SIZE_ICON_16} onClick={onCopy} className={'content-body-white spacing-m-r-1'} />
        <Text size={TextSize.XXSMALL} className={`content-body-white ${styles.prompt}`} val={props.prompt} />
      </ClickableDiv>
    );
  };

  return isCopiedClicked ? getCopiedTextElement() : getPromptTextElement();
}
